import chk0 from "../assets/chk0.gif";
import chk1 from "../assets/chk1.gif";
import { activateWorker } from "../functions/WorkersQueries";

const TrabajadoresLista = ({
	trabajadores,
	setRefrescar,
	setNuevoTrabajador,
	setCapturarIne,
	setTipoCaptura,
	setVerDatosWorker,
	setWorker,
}) => {
	const getIne = (id_usuario, tipo) => {
		setNuevoTrabajador(0);
		setVerDatosWorker(0);
		setCapturarIne(id_usuario);
		setTipoCaptura(tipo);
	};

	const verIne = (id_usuario) => {
		setNuevoTrabajador(0);
		setVerDatosWorker(1);
		setWorker(id_usuario);
	};

	return (
		<>
			<div className="text-center text-xl font-semibold text-sky-700 mt-6">
				Trabajadores:
			</div>
			<div className="flex flex-col items-center justify-center m-4 w-9/10">
				{trabajadores.length ? (
					<>
						<table className="min-w-full my-6 divide-y divide-gray-200">
							<thead className="bg-gray-50">
								<tr key="head">
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
										key="head"
									>
										Nombre
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Nombre de
										<br />
										usuario
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										CURP
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Altas
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Bajas
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Modificaciones
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Retención
										<br />
										con intereses
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Retención
										<br />
										sin intereses
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Activo
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Autorizado
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Capturar / actualizar INE
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Ver INE
									</th>
									<th
										scope="col"
										className="px-2 py-3 text-sm font-semibold tracking-wider text-center text-gray-500"
									>
										Activar / desactivar
									</th>
								</tr>
							</thead>

							{trabajadores.map((item, index) => {
								return (
									<tbody>
										<tr
											key={index}
											className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
										>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell">
												{item.nombre}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell">
												{item.username}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell">
												{item.curp}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell">
												{item.permiso_altas === "1" ? (
													<img
														src={chk1}
														alt="Si"
														key="Si"
														className="mx-auto"
													/>
												) : (
													<img
														src={chk0}
														alt="No"
														key="No"
														className="mx-auto"
													/>
												)}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell flex flex-col items-center">
												{item.permiso_bajas === "1" ? (
													<img
														src={chk1}
														alt="Si"
														key="Si"
														className="mx-auto"
													/>
												) : (
													<img
														src={chk0}
														alt="No"
														key="No"
														className="mx-auto"
													/>
												)}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell flex flex-col items-center">
												{item.permiso_modificaciones === "1" ? (
													<img
														src={chk1}
														alt="Si"
														key="Si"
														className="mx-auto"
													/>
												) : (
													<img
														src={chk0}
														alt="No"
														key="No"
														className="mx-auto"
													/>
												)}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell flex flex-col items-center">
												{item.boton_retencion_con_intereses === "1" ? (
													<img
														src={chk1}
														alt="Si"
														key="Si"
														className="mx-auto"
													/>
												) : (
													<img
														src={chk0}
														alt="No"
														key="No"
														className="mx-auto"
													/>
												)}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell flex flex-col items-center">
												{item.boton_retencion_sin_intereses === "1" ? (
													<img
														src={chk1}
														alt="Si"
														key="Si"
														className="mx-auto"
													/>
												) : (
													<img
														src={chk0}
														alt="No"
														key="No"
														className="mx-auto"
													/>
												)}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell flex flex-col items-center">
												{item.activo === 1 ? (
													<img
														src={chk1}
														alt="Si"
														key="Si"
														className="mx-auto"
													/>
												) : (
													<img
														src={chk0}
														alt="No"
														key="No"
														className="mx-auto"
													/>
												)}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell flex flex-col items-center">
												{item.autorizado === "1" ? (
													<img
														src={chk1}
														alt="Si"
														key="Si"
														className="mx-auto"
													/>
												) : (
													<img
														src={chk0}
														alt="No"
														key="No"
														className="mx-auto"
													/>
												)}
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell">
												<div className="flex flex-row items-center justify-center mx-2">
													<button
														className="mx-auto bg-gray-500 text-white rounded-xl py-1 px-3 hover:bg-slate-400 hover:text-black hover:duration-500"
														onClick={() => getIne(item.id_usuario, "anverso")}
													>
														Anverso
													</button>
													<button
														className="mx-auto bg-gray-500 text-white rounded-xl py-1 px-3 hover:bg-slate-400 hover:text-black hover:duration-500"
														onClick={() => getIne(item.id_usuario, "reverso")}
													>
														Reverso
													</button>
												</div>
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell">
												<button
													className="mx-auto bg-gray-500 text-white rounded-xl py-1 px-3 hover:bg-slate-400 hover:text-black hover:duration-500"
													onClick={() => verIne(item.id_usuario)}
												>
													Ver
												</button>
											</td>
											<td className="px-2 py-2 text-sm text-center text-gray-600 md:table-cell">
												<button
													className="mx-auto bg-gray-500 text-white rounded-xl py-1 px-3 hover:bg-slate-400 hover:text-black hover:duration-500"
													onClick={() =>
														activateWorker(item.id_usuario, setRefrescar)
													}
												>
													{item.activo === 1 ? "Desactivar" : "Activar"}
												</button>
											</td>
										</tr>
									</tbody>
								);
							})}
						</table>
					</>
				) : (
					"No se encontraron trabajadores"
				)}
			</div>
		</>
	);
};

export default TrabajadoresLista;
